<template>
	<div>
		<div class="feature-r">
			<div class="title show-one-lines" v-text="param.title"></div>
			<div class="feature-r-c d-flex">
				<template v-if="param.page_url.indexOf('http') != -1">
					<a :href="param.page_url" target="_blank" class="feature-r-img"><img class="img-default" :src="param.pic_url" alt /></a>
				</template>
				<template v-else>
					<router-link :to="param.page_url" class="feature-r-img"><img class="img-default" :src="param.pic_url" alt /></router-link>
				</template>
				
				<div class="new-r-list d-flex flex-wrap flex_1 justify-content-between">
					<router-link :to="{path:'/pages/goods/goods',query:{id:item.id}}" target="_blank" class="new-r-item d-flex" v-for="(item,index) in  param.list[0].goods_list" :key="index">
						<img class="img-default" :src="item.pic_url" alt />
						<div class="pic">
							<div v-text="item.name"></div>
							<div v-text="'¥'+item.price"></div>
						</div>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				
			};
		}
	};
</script>

<style lang="scss" scoped>
	.title {
		line-height: 56px;
		height: 56px;
		font-size: 18px;
		font-weight: 600;
		border-bottom: 1px solid #ebebeb;
		padding:0 20px;
		box-sizing: border-box;
	}

	.feature-r {
		width: 590px;
		height: 362px;
		margin-top: 20px;
		background-color: #fff;

		.feature-r-c {
			padding: 20px;
			box-sizing: border-box;

			.feature-r-img {
				width: 180px;
				height: 265px;
				margin-right: 20px;
			}

			.new-r-list {
				padding-top: 4px;
				box-sizing: border-box;

				.new-r-item {
					// width: 50%
					margin-top: 16px;
					height: 69px;

					&:hover {
						opacity: 0.8;
					}

					img {
						height: 69px;
						width: 69px;
					}

					.pic {
						margin-left: 16px;
						height: 69px;

						:first-child {
							width: 76px;
							overflow: hidden;
							height: 36px;
							line-height: 18px;
						}

						:last-child {
							font-size: 16px;
							color: #ff0e25;
							margin-top: 12px;
						}
					}
				}
			}
		}
	}
</style>
